import userManager from '../../../../userManager'
import { getRequest, putRequest } from '../../../../utils/httpRequest'
import { URL } from '../../../../config'

export const searchUser = function (prefix, suffix) {
  const url = `${URL.member}/${prefix}/${suffix}`;
  return getAccessToken().then(function (user) {
    return getRequest(url, 'json', user.access_token);
  });
}

export const sendUserInvitation = function (email, role, firstName, lastName, nationalId) {
  const url = `${URL.user}/invite`;
  return getAccessToken().then(function (user) {
    const invite = {
      email: email,
      firstName: firstName,
      lastName: lastName,
      profileAttributes: [{ 'key': 'Role', 'value': role }, { 'key': 'NationalId', 'value': nationalId }]
    }
    return putRequest(url, invite, user.access_token);
  });
}

const getAccessToken = function () {
  return userManager.getUser();
}


// WEBPACK FOOTER //
// ./src/containers/user/newuser/Logic/user.js